// ─────────────────────────────────────────────────────────────────────
// <AskSFab /> — floating action button for AI assistant
//
// Visible on desktop only (lg and up).  On mobile the raised center
// button in <MobileBottomTab /> serves the same purpose.
// ─────────────────────────────────────────────────────────────────────

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SMark from './SMark';

export default function AskSFab() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // Hide on /ask itself + on auth pages
  if (
    pathname.startsWith('/ask') ||
    pathname === '/login' ||
    pathname === '/signup'
  ) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/ask')}
      className="hidden lg:flex fixed bottom-8 right-8 z-30 items-center gap-3 rounded-full pl-2 pr-5 py-2 transition-all duration-250"
      style={{
        background: 'var(--snt-bg-1)',
        border: '1px solid var(--snt-line-strong)',
        boxShadow: '0 8px 30px rgba(0,0,0,0.5)',
      }}
      aria-label={t('ai.fab_aria', 'Ask S — AI assistant')}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--snt-accent)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--snt-line-strong)'; }}
    >
      <SMark size="md" pulse glow />
      <span
        className="text-[13px]"
        style={{ color: 'var(--snt-text)' }}
      >
        {t('ai.ask', 'Ask S')}
      </span>
    </button>
  );
}
